document.querySelectorAll('.dropdown-menu [data-check-all]').forEach(function(el) {
    let parent = el.closest('.dropdown-menu');
    el.addEventListener('click', function(e) {
        e.preventDefault();
        parent.querySelectorAll('input[type="checkbox"]').forEach(function(input) {
            input.checked = el.dataset.checkAll == 'true';
        });
    });
});